export default "__VITE_ASSET__DZP63Ca0__"